"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortDropdown = exports.SORT_DIRECTION = void 0;
var react_1 = __importStar(require("react"));
var design_system_layouts_1 = require("@contrast-security-inc/design-system-layouts");
var Dropdown_1 = require("../Dropdown");
var design_system_buttons_1 = require("@contrast-security-inc/design-system-buttons");
var design_system_foundations_1 = require("@contrast-security-inc/design-system-foundations");
var utils_1 = require("../SelectModules/utils");
var messages = __importStar(require("../SelectModules/translations"));
var css_1 = require("@emotion/css");
exports.SORT_DIRECTION = {
    ASCENDING: 'asc',
    DESCENDING: 'desc',
};
var dropdownStyles = (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-top: 0px;\n  width: calc(100% - 24px); /* inherit from SortDropdown minus button */\n\n  & fieldset {\n    border-color: ", ";\n  }\n\n  button,\n  && input,\n  .ds-dropdown-input-value {\n    padding-top: 8px;\n    padding-bottom: 8px;\n  }\n"], ["\n  padding-top: 0px;\n  width: calc(100% - 24px); /* inherit from SortDropdown minus button */\n\n  & fieldset {\n    border-color: ", ";\n  }\n\n  button,\n  && input,\n  .ds-dropdown-input-value {\n    padding-top: 8px;\n    padding-bottom: 8px;\n  }\n"])), design_system_foundations_1.theme.color.neutral50);
var isSortOptionWithInitialSortType = function (option) {
    return typeof option === 'object' && option && 'initialSortDirection' in option;
};
var SortDropdownInner = function (_a, ref) {
    var _b = _a.sortDirection, sortDirection = _b === void 0 ? exports.SORT_DIRECTION.ASCENDING : _b, options = _a.options, sortOption = _a.sortOption, onSortChange = _a.onSortChange, DropdownProps = _a.DropdownProps, className = _a.className, testId = _a.testId, label = _a.label, rest = __rest(_a, ["sortDirection", "options", "sortOption", "onSortChange", "DropdownProps", "className", "testId", "label"]);
    var formatMessage = (0, design_system_foundations_1.useLocalizationContext)().formatMessage;
    var handleSortOptionChanged = function (option) {
        // Options do not have sort direction
        if (!option || !options.find(function (option) { return isSortOptionWithInitialSortType(option); })) {
            onSortChange({ sortDirection: sortDirection, sortOption: option });
        }
        else {
            // find the matching sort option
            var safelyCallItemToID_1 = function (option) {
                return (0, utils_1.setupSafelyCallItemToID)(DropdownProps === null || DropdownProps === void 0 ? void 0 : DropdownProps.itemToID, utils_1.determineItemValue, option);
            };
            var matchingOption = options.find(function (eachOption) { return safelyCallItemToID_1(eachOption.option) === safelyCallItemToID_1(option); });
            onSortChange({
                sortDirection: matchingOption === null || matchingOption === void 0 ? void 0 : matchingOption.initialSortDirection,
                sortOption: option,
            });
        }
    };
    var handleSortDirectionChanged = function () {
        return onSortChange({
            sortOption: sortOption,
            sortDirection: sortDirection === exports.SORT_DIRECTION.ASCENDING ? exports.SORT_DIRECTION.DESCENDING : exports.SORT_DIRECTION.ASCENDING,
        });
    };
    return (react_1.default.createElement(design_system_layouts_1.Stack, __assign({}, rest, { spacing: "4px", ref: ref, className: (0, css_1.cx)('ds-sort-dropdown', className), testId: testId }),
        react_1.default.createElement(design_system_buttons_1.IconButton, { "aria-label": sortDirection === exports.SORT_DIRECTION.ASCENDING
                ? formatMessage(messages, 'ascending')
                : formatMessage(messages, 'descending'), testId: "".concat(testId, "-sort-direction-button"), variant: "primary", onClick: handleSortDirectionChanged, Icon: sortDirection === exports.SORT_DIRECTION.ASCENDING ? design_system_foundations_1.IconArrowUp : design_system_foundations_1.IconArrowDown }),
        react_1.default.createElement(Dropdown_1.Dropdown, __assign({}, DropdownProps, { className: (0, css_1.cx)(DropdownProps === null || DropdownProps === void 0 ? void 0 : DropdownProps.className, dropdownStyles), label: label || formatMessage(messages, 'sortBy'), testId: "".concat(testId, "-sort-option-dropdown"), items: options.map(function (option) {
                return isSortOptionWithInitialSortType(option) ? option.option : option;
            }), value: sortOption, onChange: function (_evt, option) { return handleSortOptionChanged(option); } }))));
};
SortDropdownInner.displayName = 'SortDropdown';
exports.SortDropdown = (0, react_1.forwardRef)(SortDropdownInner);
var templateObject_1;
